import React from 'react';
import './InfoPanel.scss';

interface InfoPanelProps {
  header: string;
  children: React.ReactNode;
  className?: string;
}

const InfoPanel: React.FC<InfoPanelProps> = ({ header, children, className }) => (
  <div className={`info-panel ${className || ''}`}>
    <div className="info-panel-header">{header}</div>
    <div className="info-panel-body">{children}</div>
  </div>
);

export default InfoPanel;
